function getInitialTouchedData(data) {
  return Object.keys(data).reduce((findedFields, key) => ({ ...findedFields, [key]: false }), {});
}

export default getInitialTouchedData;
